import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { provideOutlet, OutletPosition } from "@spartacus/storefront";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { AccountOverviewModule } from "../account-overview/account-overview.module";
import { StsCustomerUploadComponent } from "./sts-customer-upload/sts-customer-upload.component";
import { StsMarketingToolComponent } from "./sts-marketing-tool/sts-marketing-tool.component";
import { StsOrderExportComponent } from "./sts-order-export/sts-order-export.component";
import { StsShippingCommitmentComponent } from "./sts-shipping-commitment/sts-shipping-commitment.component";
import { StsShippingWeekComponent } from "./sts-shipping-week/sts-shipping-week.component";
import { StsTierManagementComponent } from "./sts-tier-management/sts-tier-management.component";


@NgModule({
  declarations: [StsCustomerUploadComponent, StsTierManagementComponent, StsShippingWeekComponent, StsShippingCommitmentComponent, StsMarketingToolComponent, StsOrderExportComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    BsDatepickerModule,
    ReactiveFormsModule,
    NgbModule,
    NgSelectModule,
    AccountOverviewModule
  ],
  providers: [
    provideOutlet({
      id: 'STSMarketingAnalysisSlot',
      position: OutletPosition.REPLACE,
      component: StsMarketingToolComponent,
    }),
    provideOutlet({
      id: 'STSCustomerUploadSlot',
      position: OutletPosition.REPLACE,
      component: StsCustomerUploadComponent,
    }),
    provideOutlet({
      id: 'STSTierMangementSlot',
      position: OutletPosition.REPLACE,
      component: StsTierManagementComponent,
    }),
    provideOutlet({
      id: 'STSShipCommitmentSlot',
      position: OutletPosition.REPLACE,
      component: StsShippingCommitmentComponent,
    }),
    provideOutlet({
      id: 'STSShippingWeekSlot',
      position: OutletPosition.REPLACE,
      component: StsShippingWeekComponent,
    }),
    provideOutlet({
      id: 'STSExportOrder',
      position: OutletPosition.REPLACE,
      component: StsOrderExportComponent,
    })
  ]
})
export class StsAdminModule { }
